
import React, {useEffect} from "react";
import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import FormFilterPicker from "root/ReactHookForm/ui/FormFilterPicker";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import {useWatch} from "react-hook-form";
import {LunchReportFormSections} from "root/s360components/LunchReport/LunchReportPage";
import DropdownProviderEYFSGroups from "root/ReactHookForm/ui/DropdownProviderEYFSGroups";
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents";
import DropdownProviderEYFSGroupMembers from "root/ReactHookForm/ui/DropdownProviderEYFSGroupMembers";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";
import DropdownClassList from "root/s360components/ReactHookForm/ui/DropdownClassList";


export const SchoolGroupPupilOffsets = {
    SCHOOL: 0,
    CLASS: 1,
    PUPIL: 2
}

export const LunchReportPersonsNames = {
    FILTER: 'filter',
    CLASS: 'class_id',
    PUPIL: 'pupil_id'
}

export const lunchReportPersonsSelected = () =>
{
    return {
        [LunchReportFormSections.PEOPLE]:
            {
                [LunchReportPersonsNames.FILTER]: SchoolGroupPupilOffsets.SCHOOL,
                [LunchReportPersonsNames.CLASS]: null,
                [LunchReportPersonsNames.PUPIL]: null,
            }
    }
}

const HookSubFormSchoolGroupPupil = ({control, sectionName, resetField, getValues, school_id, readOnly, formErrors}) =>
{

    const [ groupId ] = useWatchDropdown( {control, name: sectionName + '.' + LunchReportPersonsNames.CLASS, isInt: false, namedField: 'group_id' }) ;

    const values = [
        { offset: SchoolGroupPupilOffsets.SCHOOL, label: 'School'},
        { offset: SchoolGroupPupilOffsets.CLASS, label: 'Class'},
        { offset: SchoolGroupPupilOffsets.PUPIL, label: 'Pupil'},
    ];

    const personsFilter = useWatch({
        control: control,
        name: sectionName + '.' + LunchReportPersonsNames.FILTER,
    });

    useEffect(() =>
    {
        const cur = getValues(sectionName);

        //Explicitly setting group_id and pupil_id to null to reset group id when moving across filters
        resetField(sectionName, {
            defaultValue: {
                [LunchReportPersonsNames.FILTER]: cur[LunchReportPersonsNames.FILTER],
                [LunchReportPersonsNames.CLASS]: null,
                [LunchReportPersonsNames.PUPIL]: null
            }
        });

    }, [personsFilter])

    const validateGroup = (val) =>
    {
        if (val === null)
        {
            return "Please Select a Group/Class.";
        }
    }

    const validateChild = (val) =>
    {
        if (val === null)
        {
            return "Please Select a Pupil.";
        }
    }

    return (
        <S360WidgetBlock title=''>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormFilterPicker values={values} name={sectionName + '.' + LunchReportPersonsNames.FILTER} control={control}/>
                </BootstrapCol>

                {personsFilter === SchoolGroupPupilOffsets.CLASS &&
                    <BootstrapCol width={12}>
                        <BootstrapRow>
                            <BootstrapCol width={6}>
                                <h5>Select a Group/Class</h5>
                                <DropdownClassList school_id={school_id}
                                                            name={sectionName + '.' + LunchReportPersonsNames.CLASS}
                                                            control={control} rules={{validate: validateGroup}}
                                                            placeHolder='Pick a Group' readOnly={readOnly}
                                                            class_id_filter={null}/>
                                <SmartErrorDiv sectionName={sectionName} name={LunchReportPersonsNames.CLASS}
                                               formErrors={formErrors}/>
                            </BootstrapCol>
                        </BootstrapRow>
                    </BootstrapCol>}

                {personsFilter === SchoolGroupPupilOffsets.PUPIL &&
                    <BootstrapCol width={12}>
                        <BootstrapRow>
                            <BootstrapCol width={6}>
                                <h5>Select a Group/Class</h5>
                                <DropdownClassList school_id={school_id}
                                                   name={sectionName + '.' + LunchReportPersonsNames.CLASS}
                                                   control={control} rules={{validate: validateGroup}}
                                                   placeHolder='Pick a Group' readOnly={readOnly}
                                                   class_id_filter={null}/>
                                <SmartErrorDiv sectionName={sectionName} name={LunchReportPersonsNames.CLASS}
                                               formErrors={formErrors}/>
                            </BootstrapCol>
                            <BootstrapCol width={6}>
                                <h5>Select a Pupil</h5>
                                <DropdownProviderEYFSGroupMembers enc_group_id={groupId}
                                                                  name={sectionName + '.' + LunchReportPersonsNames.PUPIL}
                                                                  control={control} rules={{validate: validateChild}}
                                                                  placeHolder='Pick a Child'
                                                                  readOnly={groupId === null}/>
                                <SmartErrorDiv sectionName={sectionName} name={LunchReportPersonsNames.PUPIL}
                                               formErrors={formErrors}/>
                            </BootstrapCol>
                        </BootstrapRow>
                    </BootstrapCol>}

            </BootstrapRow>
        </S360WidgetBlock>
    )
}

export default HookSubFormSchoolGroupPupil;